import { useEffect } from 'react';

export function useScrollReveal(deps = []) {
  useEffect(() => {
    const els = document.querySelectorAll(
      '.reveal-left, .reveal-right, .reveal-up'
    );
    if (!els.length) return;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    els.forEach(el => observer.observe(el));
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
